// src/components/Footer.js
import React from 'react';

const Footer = () => (
    <footer className="border-t border-[#e2e8f0] bg-[#f8fafc] py-4 text-center text-xs font-bold text-[#475569]">
    This site was made by Keenan Jajeh © 2026 
  </footer>
);

export default Footer;
